export default {
  PROFORMA: 2,
  VAT: 6,
  FM: 8,
  KLA: 9,
  CORRECTION: 10,
  CURRENCY: 11,
  CURRENCY_CORRECTION: 12,
  FM_CORRECTION: 13,
  ADVANCE_CORRECTION: 14,
  FINAL_CORRECTION: 15,
  FINAL: 4,
  ADVANCED: 3,
};
